import React, { useEffect, useState } from 'react';
import Frame from 'react-frame-component';
import initialContent from '../../iframe_initial_content';
import Homepage from '../page/homepage';
import DrillDownPage from '../page/drillDownPage';

/**
 * Live component for rendering iframed content
 *
 * This component encapsulates the logic for rendering either a Homepage or DrillDownPage
 * within an iframe. It handles the timing and re-rendering of the iframe content.
 *
 * @param {string} measureId - Measure identifier (defaults to '')
 * @param {string} planNodeId - Plan node identifier (defaults to '')
 * @param {Array} ancestor - Ancestor data (defaults to [])
 * @param {Object} deviceDimensionStyle - Styling for device dimensions (defaults to {})
 * @param {boolean} isDrillDownPage - Flag to determine which page to render (defaults to false)
 * @param {Object} cache - Data cache (defaults to {})
 * @param {Object} generalSettings - General settings (defaults to {})
 * @param {Array} items - Navigation items (defaults to [])
 * @returns {React.Component} Iframe-wrapped page component
 */

export default function Live({
  measureId = '',
  planNodeId = '',
  ancestor = [],
  deviceDimensionStyle = {},
  isDrillDownPage = false,
  cache = {},
  generalSettings = {},
  items = [],
}) {
  const RENDER_DELAY_MS = 500;

  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(0);
  }, [measureId, planNodeId, ancestor, deviceDimensionStyle, isDrillDownPage, cache, generalSettings, items]);

  useEffect(() => {
    if (!count) {
      const timer = setTimeout(() => {
        setCount((prev) => prev + 1);
      }, RENDER_DELAY_MS);

      return () => clearTimeout(timer);
    }
  }, [count]);

  return (
    <Frame
      initialContent={initialContent.replace(
        '<div id="mount-here">',
        `
            <div
                id="mount-here"
                class="${['page', measureId || planNodeId || 'home'].join('-')} ${measureId ? 'measure-' : ''}level-${
                  ancestor.length + (planNodeId ? 1 : 0)
                }"
            >
        `,
      )}
      mountTarget="#mount-here"
      style={deviceDimensionStyle}
    >
      {isDrillDownPage ? (
        <DrillDownPage ancestor={ancestor} linkPrefix={false} branding data={cache} settings={generalSettings} navs={items} />
      ) : (
        <Homepage linkPrefix={false} branding data={cache} settings={generalSettings} navs={items} />
      )}
    </Frame>
  );
}
